import { WifiStarIcon } from './WifiStarIcon';

/**
 * author: Michael Irigoyen
 * id 30694858-4607-48C1-A533-861E4968A0CE
 * name wifi-star
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-star.svg
 * tags
 */
export const NetworkFavouriteIcon = WifiStarIcon;
export default NetworkFavouriteIcon